module.exports = __webpack_public_path__ + "img/analysis2.7bc854bf.jpg";